import { Transforms } from "slate";
export const createImageNode = ({ alt, src }) => ({
    type: "image",
    alt,
    src,
    children: [{ text: "" }]
});
export const insertImage = (editor, src, alt = "") => {
    if (!src) {
        return;
    }
    Transforms.insertNodes(editor, createImageNode({ src, alt }), { select: true });
};
export const withImages = (editor) => {
    const { isVoid, isInline } = editor;
    editor.isVoid = (element) => (element.type === "image" ? true : isVoid(element));
    editor.isInline = (element) => (element.type === "image" ? true : isInline(element));
    return editor;
};
